import React, { useEffect, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import useAws from '../../hooks/useAws';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/type';

interface PartialModalProps {
  open: boolean;
  handleClickPgm: () => void;
  handleClickClean: () => void;
  close: () => void;
  isOverTimeLimit: boolean;
}

const useStyles = makeStyles((theme) => ({
  actions: {
    display: "flex",
    padding:'20px',
  },
  button: {
    minWidth:'100px',
    color: "#fff",
  },
  pgm: {
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    "&:hover": {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
  },
  clean: {
    backgroundColor: 'rgba(202, 90, 150, 1.0)',
    "&:hover": {
      backgroundColor: 'rgba(202, 90, 150, 0.9)',
    },
  },
  errorText: {
    fontSize: '12px',
    marginTop: '6px',
  },
  disabledButton: {
    backgroundColor: 'grey',
  }
}));

export default function PartialModal({ open, handleClickPgm, handleClickClean, close, isOverTimeLimit }: PartialModalProps) {
  const classes = useStyles();

  const { onRequestCheckObject } = useAws();

  const { selectedAsset } = useSelector((state: RootState) => state.asset);
  const { exist } = useSelector((state: RootState) => state.aws);

  function getS3Key(cloudFrontUrl: string) {
    if (!cloudFrontUrl) {
      return '';
    }

    const url = new URL(cloudFrontUrl);

    return decodeURIComponent(url.pathname.substring(1));
  }

  useEffect(() => {
    const proxyPath = selectedAsset?.filePath.proxy?.cloudfront || '';

    if (proxyPath) {
      const key = getS3Key(selectedAsset?.filePath.proxy.cloudfront);
      onRequestCheckObject({ key });
    }

  }, [selectedAsset, open])

  const canPartialClean = useMemo(() => {
    return exist;
  }, [selectedAsset, exist]);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>부분인출 선택</DialogTitle>
      <DialogContent>
        <Typography>영상 타입을 선택해주세요.</Typography>
        {isOverTimeLimit && (
          <Typography
            color='error'
            className={classes.errorText}
          >
            * 클린본 부분인출은 1분 미만만 가능합니다.
          </Typography>
        )}
        {!canPartialClean && (
          <Typography
            color='error'
            className={classes.errorText}
          >
            * 현재 클린본 업로드 중으로 부분 인출이 제한됩니다.
          </Typography>
        )}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleClickPgm}
          className={`${classes.button} ${classes.pgm}`}
        >
          방송본
        </Button>
        <Button
          onClick={handleClickClean}
          className={`${classes.button} ${classes.clean} ${isOverTimeLimit && classes.disabledButton}`}
          disabled={isOverTimeLimit || !canPartialClean}
        >
          클린본
        </Button>
      </DialogActions>
    </Dialog>
  );
}
